import { FC } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { toast } from "react-toastify";

import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import FileCopyIcon from "@mui/icons-material/FileCopy";

import styles from "./style";

import CustomLink from "components/CustomLink";

interface SectionStorePartnerContactProps {
  email: string;
}

const SectionStorePartnerContact: FC<SectionStorePartnerContactProps> = ({
  email,
}) => {
  const handleCopy = () => {
    toast.success("Address copied.");
  };

  return (
    <>
      <Typography mb={0.5}>
        If you have any questions or would like to raise a complaint about the
        item, please contact the Store Owner by e-mail.
      </Typography>
      <Box>
        <Typography display="inline-block" variant="h3">
          <CustomLink href={`mailto:${email}`} sx={{ color: "secondary.main" }}>
            {email}
          </CustomLink>
        </Typography>
        <Box ml={1} component="span">
          <CopyToClipboard text={email} onCopy={handleCopy}>
            <FileCopyIcon fontSize="small" sx={styles.icon} />
          </CopyToClipboard>
        </Box>
      </Box>
    </>
  );
};

export default SectionStorePartnerContact;
